import { useRouter, useSearchParams } from 'next/navigation';
import React, { createContext, useContext, useEffect, useState } from 'react';

export interface ISearchData {
	isSearchOpen: boolean;
	updateSearchOpen: (isOpen: boolean) => void;
}
const SearchDataContext = createContext<ISearchData>({} as ISearchData);

interface ISearchDataProviderProps {
	children: React.ReactNode | React.ReactNode[];
}

export const SearchDataProvider = ({ children }: ISearchDataProviderProps) => {
	const params = useSearchParams();
	const searchParam = params.get('search');
	const query = searchParam || searchParam === '' ? searchParam : undefined;
	const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false);

	useEffect(() => {
		if (!isSearchOpen && query !== undefined) {
			setIsSearchOpen(true);
		} else if (isSearchOpen && query === undefined) {
			setIsSearchOpen(false);
		}
	}, [query]);

	const router = useRouter();
	const searchParams = useSearchParams();
	const updateSearchOpen = (isOpen: boolean) => {
		setIsSearchOpen(isOpen);

		// delete 'search' searchParam when closing search
		if (!isOpen) {
			const newSearchParam = new URLSearchParams(searchParams);
			newSearchParam.delete('search');
			const newUrl = `?${newSearchParam.toString()}`;
			router.push(newUrl);
		}
	};

	return (
		<SearchDataContext.Provider
			value={{
				isSearchOpen,
				updateSearchOpen,
			}}
		>
			{children}
		</SearchDataContext.Provider>
	);
};
export const useSearchData = () => useContext(SearchDataContext);
